import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})

export class AppHttpService {
  public static readonly _postalCodeType = 14;
  public static readonly _cityStateType = 15;
  public static readonly _regionType = 16;
  public static readonly _stateType = 17;
  public static readonly _countryType = 18;

  public static readonly _searchAreaNation = 1;
  public static readonly _searchAreaState = 2;
  public static readonly _searchAreaRegion = 3;
  public static readonly _searchAreaCity = 4;
  public static readonly _searchAreaPostalCode = 5;

  public _addressType: number;
  public _searchArea: number;

  constructor(
	  protected http: HttpClient,
	  protected configuration: ConfigurationService,
	) { }

  protected httpOptions = {
	  headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Access-Control-Allow-Origin': '*',
					Accept: 'application/json, text/plain, */*'
				})
		, withCredentials: true
	};

  public getAddressLocation(pLocation: any, pAddComma: boolean = false) {
	  let retAddress = '';
	  const state = pLocation.state !== undefined ? pLocation.state : pLocation.region;
	  retAddress = state;
	  const mType = pLocation.Type !== undefined ? pLocation.Type : 0;

	  if ((pLocation !== undefined) && (pLocation != null) && (pLocation.city !== undefined)) {
		  switch (mType) {
			  case AppHttpService._postalCodeType:
				  retAddress = pLocation.postalCode;
				  this._searchArea = AppHttpService._searchAreaPostalCode;
				  this._addressType = 1;
				  break;

			  case AppHttpService._stateType:
				  retAddress = state;
				  this._searchArea = AppHttpService._searchAreaState;
				  this._addressType = 0;
				  break;

			  case AppHttpService._countryType:
				  retAddress = pLocation.Country;
				  this._searchArea = AppHttpService._searchAreaNation;
				  this._addressType = 0;
				  break;

			  case AppHttpService._cityStateType:
				  retAddress = pLocation.city + (pAddComma ? ', ' : ' ') + state;
				  this._searchArea = AppHttpService._searchAreaCity;
				  this._addressType = 0;
				  break;

			  default:
				  retAddress = pLocation.city + (pAddComma ? ', ' : ' ') + state;
				  this._searchArea = AppHttpService._searchAreaCity;
				  this._addressType = 0;
				  break;
		  }
	  }

	  return retAddress;
  }

  public async getLocationByGeoip() {
	  const url = 'https://geolocation-db.com/json';
	  let ret = '';
	  return this.http.get(url, this.httpOptions).toPromise().then(
		  (respData: any) => {
		    ret = respData.IPv4;
		    return ret;
		  },
		  error => {
		    console.error(error);
		    return ret;
		  })
		  .catch ((err: any) => {
		    console.error(err);
		    return '';
		});
  }

  public async getDefaultLocation() {
	  const url = 'https://pro.ip-api.com/json?key=' + ConfigurationService.SETTING_IP_API_KEY;
	  return this.http.get(url).toPromise().then ((res: any) => {
		  return this.getAddressLocation(res);
		})
		.catch((err: any) => {
		  console.error(err);
		  return '';
		});
  }
}
